import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";

export default function TopLogout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); 
    } catch (err) {
      console.error(err);
      alert("Logout failed.");
    }
  };

  return (
    <button onClick={handleLogout} style={styles.logoutBtn}>
      Logout
    </button>
  );
}

const styles = {
  logoutBtn: {
    position: "fixed",
    top: "15px",
    right: "15px",
    background: "#000000",
    color: "red",
    border: "none",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "14px",
    cursor: "pointer",
    zIndex: 2000,
    boxShadow: "0 0 10px black",
  }
};
